import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {IconSearch, IconWithProps} from "../../../@models/icons";
import {NbPosition, NbTrigger} from "@nebular/theme";
import {InputTextComponent} from "../input-text/input-text.component";

@Component({
  selector: 'app-input-search',
  templateUrl: './input-search.component.html',
  styleUrls: ['./input-search.component.scss']
})
export class InputSearchComponent implements OnInit {
  @Input() advancedMode: boolean = false;
  @Input() tooltip: string = "";
  @Input() value: any = '';
  @Input() clearSearch: boolean = false;

  @Output() onInputChange = new EventEmitter<any>();

  @ViewChild(InputTextComponent) inputText?: InputTextComponent;

  iconSearch = IconSearch;
  popoverPosition = NbPosition.BOTTOM;
  trigger: NbTrigger = NbTrigger.FOCUS;
  helpDisabled: boolean = false;

  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    if (this.advancedMode) {
      this.iconSearch = IconWithProps(this.iconSearch, {'status': 'primary'}); // status para indicar que admite +,- y *
    }
  }

  async onSearch(value: string) {
    this.helpDisabled = true;
    this.onInputChange.emit(value);
  }

  onFocus() {
    this.helpDisabled = false;
  }

  clearInput() {
    this.value = '';
    this.onInputChange.emit(this.value);
    this.cdr.detectChanges();
  }
}
